import { operatorConfig, operatorSession } from '../auth/runtime';
import { apiConfig } from './config';
import type { ServiceDefinition } from './http/client';
import { dataErrorEnvelope, rawEnvelope } from './http/envelopes';

/**
 * 서버 목록 — MSA라 서버마다 주소·인증·응답 봉투·쿼리 형식이 다르다. 화면은 이름(api.core 등)으로만 고른다.
 * 새 서버는 여기에 항목 하나를 더하고, 맞는 envelope·auth를 고르거나 hooks로 전용 동작을 붙인다.
 *
 * 규칙은 2026-10 조사 기준 각 서버의 현재 규약을 따랐다. 코어와 인증 서버 계정 API는 운영자 OAuth 세션 토큰을 쓴다.
 */
export const SERVICES = {
  /** 신규 통합 코어 API(mgrv-core-api /api/v1) — 인증 서버 토큰을 쓴다 */
  core: {
    label: '코어 API',
    baseUrl: operatorConfig?.coreApiUrl,
    envKey: 'VITE_CORE_API_URL',
    envelope: dataErrorEnvelope,
    auth: { scheme: 'bearer', tokens: operatorSession.tokens, required: true },
    arrayFormat: 'repeat',
    allowDevelopmentCoreProxyHttp: import.meta.env.DEV,
  },
  /** 인증 서버(mgrv-auth-api) — 토큰 발급·갱신 자체를 하므로 인증·갱신을 걸지 않는다 */
  auth: {
    label: '인증 서버',
    baseUrl: apiConfig.authApiUrl,
    envKey: 'VITE_AUTH_API_URL',
    envelope: rawEnvelope,
    auth: { scheme: 'none' },
    arrayFormat: 'repeat',
  },
  /** 인증 서버 계정·세션 API(/api/v1/*) — 같은 서버지만 로그인 토큰(Bearer)으로 호출한다 */
  authApi: {
    label: '인증 서버 계정 API',
    baseUrl: apiConfig.authApiUrl,
    envKey: 'VITE_AUTH_API_URL',
    envelope: rawEnvelope,
    auth: { scheme: 'bearer', tokens: operatorSession.tokens, required: true },
    arrayFormat: 'repeat',
  },
} satisfies Record<string, ServiceDefinition>;

export type ServiceName = keyof typeof SERVICES;
